import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material';

import { SharedModule } from '../../shared';
import { MessageModule } from '../../shared/message/message.module';
import { HomeMaterialModule } from '../home-material/home-material.module';

import { ManageClaimsComponent } from './manage-claims.component';
import { ClaimByPoComponent } from './components/claim-by-po/claim-by-po.component';
import { SalesChallengeClaimsComponent } from './components/sales-challenge-claims/sales-challenge-claims.component';
import { ClaimedEarningsComponent } from './components/claimed-earnings/claimed-earnings.component';
import { ActivityChallengeClaimsComponent } from './components/activity-challenge-claims/activity-challenge-claims.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatTableModule,
    MatProgressSpinnerModule,
    HomeMaterialModule,
    MessageModule,
    SharedModule,
  ],
  declarations: [
    ManageClaimsComponent,
    ClaimByPoComponent,
    SalesChallengeClaimsComponent,
    ClaimedEarningsComponent,
    ActivityChallengeClaimsComponent,
  ],
  exports: [
    ManageClaimsComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class ManageClaimsModule {}
